module.exports = __webpack_public_path__ + "static/img/create3.264b935.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/create3.png
// module id = 907
// module chunks = 1